(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-reels"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('video-reels')) return;
    const DESK = window.matchMedia('(min-width: 1000px)');
    const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
    const ICON = {
      close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
      muted: '<svg class="vr-i-muted" viewBox="0 0 24 24" fill="currentColor"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16.5 9.5l5 5m0-5l-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>',
      sound: '<svg class="vr-i-sound" viewBox="0 0 24 24" fill="currentColor"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 8.5a5 5 0 010 7M18.5 6a8.5 8.5 0 010 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>',
      play: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>',
      left: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>',
      right: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>',
    };
    // No HLS: Shopify's master playlist lists the 1080p/11Mbps variant FIRST and Safari starts on it,
    // which left every reel black for seconds. Plain faststart MP4s start after ~1s of data.
    const playSafe = (v) => { const p = v.play(); if (p && p.catch) p.catch(() => {}); };

    // iOS-safe scroll lock (overflow:hidden alone lets the page scroll under a fixed layer)
    let lockY = 0;
    const lock = () => {
      lockY = window.scrollY;
      Object.assign(document.body.style, { position: 'fixed', top: `-${lockY}px`, left: '0', right: '0', width: '100%' });
    };
    const unlock = () => {
      Object.assign(document.body.style, { position: '', top: '', left: '', right: '', width: '' });
      window.scrollTo(0, lockY);
    };

    class VideoReels extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.vr__track');
        this.cards = [...this.querySelectorAll('.vr__card')];
        if (!this.cards.length) return;
        this.videos = this.cards.map((c) => c.querySelector('video'));
        this.overlay = parseFloat(this.dataset.overlay) || 0.48;
        this.sideScale = parseFloat(this.dataset.scale) || 0.9;
        this.autoOn = this.dataset.auto === 'true';
        this.maxSec = parseFloat(this.dataset.max) || 0;
        this.active = 0;
        this.visible = new Set();
        this.inView = false;
        this.lastTouch = 0;
        this.elapsed = 0;
        this.ac = new AbortController();
        const sig = { signal: this.ac.signal };

        // Load + play only reels that are on screen; pause the rest (10 videos otherwise melt a phone).
        // Buffer ahead: attach sources about one screen before the reels are reached,
        // so they're already playable by the time they scroll in.
        this.videos.forEach((v) => {
          v.addEventListener('playing', () => v.parentElement.classList.add('is-ready'), { once: true });
        });
        this.pre = new IntersectionObserver((entries) => {
          for (const e of entries) {
            if (!e.isIntersecting) continue;
            const v = e.target.querySelector('video');
            if (!v.src) { v.preload = 'auto'; v.src = v.dataset.src; v.load(); }
            this.pre.unobserve(e.target);
          }
        }, { rootMargin: '100% 60% 100% 60%' });
        this.cards.forEach((c) => this.pre.observe(c));

        this.io = new IntersectionObserver((entries) => {
          for (const e of entries) {
            const v = e.target.querySelector('video');
            if (e.isIntersecting) {
              if (!v.src) { v.preload = 'auto'; v.src = v.dataset.src; v.load(); }
              this.visible.add(v);
              if (!this.lb?.open) playSafe(v);
            } else {
              this.visible.delete(v);
              v.pause();
              if (!v.muted) this.setMuted(v, true);
            }
          }
        }, { rootMargin: '0px 200px 0px 200px', threshold: 0.2 });
        this.cards.forEach((c) => this.io.observe(c));
        this.secIO = new IntersectionObserver(([e]) => {
          this.inView = e.intersectionRatio >= 0.5;
          if (e.isIntersecting) this.warm(this.active - 1, DESK.matches ? 6 : 4);
        }, { threshold: [0, 0.5, 1] });
        this.secIO.observe(this);

        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true, ...sig });
        ['pointerdown', 'touchstart', 'wheel'].forEach((t) => this.track.addEventListener(t, () => { this.lastTouch = Date.now(); }, { passive: true, ...sig }));
        window.addEventListener('resize', () => { this.onScroll(); this.fitHead(); }, sig);
        this.fitHead();
        document.fonts?.ready.then(() => this.fitHead());
        DESK.addEventListener('change', () => this.onScroll(), sig);

        this.cards.forEach((card, i) => {
          card.querySelector('.vr__mute').addEventListener('click', (e) => {
            e.stopPropagation();
            this.lastTouch = Date.now();
            const v = this.videos[i];
            const turnOn = v.muted;
            if (turnOn) this.videos.forEach((o) => o !== v && this.setMuted(o, true));
            this.setMuted(v, !turnOn);
            if (turnOn) playSafe(v);
          }, sig);
          card.querySelector('.vr__expand').addEventListener('click', (e) => { e.stopPropagation(); this.openLb(i); }, sig);
          card.addEventListener('click', () => {
            if (!DESK.matches && i !== this.active) this.goTo(i);
            else this.openLb(i);
          }, sig);
        });

        // Native theme arrows dispatch control:prev/next on the element they control (our track).
        this.track.addEventListener('control:prev', () => this.page(-1), sig);
        this.track.addEventListener('control:next', () => this.page(1), sig);

        document.addEventListener('shopify:block:select', (e) => {
          const i = this.cards.findIndex((c) => c.contains(e.target) || c === e.target);
          if (i > -1) this.goTo(i);
        }, sig);

        this.timer = setInterval(() => this.tick(), 250);
        // Phones open on the 2nd reel so there's a peeking video on BOTH sides, like the mock.
        requestAnimationFrame(() => {
          if (!DESK.matches && this.cards.length >= 3) this.goTo(1, false);
          this.onScroll();
        });
      }

      fitHead() {
        this.querySelectorAll('.vr__title, .vr__sub').forEach((el) => {
          el.style.fontSize = '';
          if (DESK.matches || !el.clientWidth) return;
          const fs = parseFloat(getComputedStyle(el).fontSize);
          if (el.scrollWidth > el.clientWidth) el.style.fontSize = `${Math.floor(fs * (el.clientWidth / el.scrollWidth) * 10) / 10}px`;
        });
      }

      disconnectedCallback() {
        this.ac?.abort();
        this.io?.disconnect();
        this.pre?.disconnect();
        this.secIO?.disconnect();
        clearInterval(this.timer);
        this.lb?.el.remove();
      }

      // Reels further along the slider are clipped by the track, so the observers never see them.
      // Keep the next couple loading ahead of wherever the shopper is.
      warm(from, count) {
        for (let j = Math.max(0, from); j < Math.min(this.videos.length, from + count); j++) {
          const v = this.videos[j];
          if (!v.src) { v.preload = 'auto'; v.src = v.dataset.src; v.load(); }
        }
      }

      setMuted(v, muted) {
        v.muted = muted;
        const btn = v.parentElement.querySelector('.vr__mute');
        btn.setAttribute('aria-pressed', String(!muted));
        btn.setAttribute('aria-label', muted ? 'Turn sound on' : 'Turn sound off');
      }

      metrics() {
        const card = this.cards[0];
        return { w: card.offsetWidth, gap: parseFloat(getComputedStyle(this.track).columnGap) || 0 };
      }

      onScroll() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          const { w, gap } = this.metrics();
          const desk = DESK.matches;
          const mid = this.track.scrollLeft + this.track.clientWidth / 2;
          let best = 0, bestD = Infinity;
          this.cards.forEach((c, i) => {
            const d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid) / (w + gap);
            if (d < bestD) { bestD = d; best = i; }
            const t = desk ? 0 : Math.min(1, d);
            c.style.setProperty('--vr-s', (1 - (1 - this.sideScale) * t).toFixed(4));
            c.style.setProperty('--vr-o', (this.overlay * t).toFixed(4));
          });
          if (desk) best = Math.round(this.track.scrollLeft / (w + gap));
          if (this.inView || this.track.scrollLeft > 0) this.warm(best - 1, desk ? 6 : 4);
          if (best !== this.active) {
            this.active = best;
            this.elapsed = 0;
            // Swiping always silences: whichever reel had sound goes back to muted.
            if (!desk) this.videos.forEach((v) => !v.muted && this.setMuted(v, true));
          }
          this.paintBar();
        });
      }

      goTo(i, smooth = true) {
        const n = this.cards.length;
        i = ((i % n) + n) % n;
        const c = this.cards[i];
        const left = DESK.matches ? c.offsetLeft : c.offsetLeft - (this.track.clientWidth - c.offsetWidth) / 2;
        this.track.scrollTo({ left, behavior: smooth && !REDUCED.matches ? 'smooth' : 'auto' });
      }

      page(dir) {
        const { w, gap } = this.metrics();
        const per = DESK.matches ? Math.max(1, Math.floor((this.track.clientWidth + gap) / (w + gap))) : 1;
        this.track.scrollBy({ left: dir * per * (w + gap), behavior: REDUCED.matches ? 'auto' : 'smooth' });
      }

      // Tell the theme's arrows when we reach an edge (they listen for scroll:edge-* like on scroll-carousel).
      paintBar() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        // Drive the theme's bar ourselves (same formula as its scroll-progress) so it always follows the reels.
        const bar = this.querySelector('scroll-progress');
        if (bar) bar.style.setProperty('--scroll-progress', Math.max(0, Math.min(1, (this.track.scrollLeft + this.track.clientWidth) / this.track.scrollWidth)).toFixed(6));
        this.querySelector('.vr__viewport').classList.toggle('is-scrollable', max > 2);
        const edge = this.track.scrollLeft <= 2 ? 'start' : this.track.scrollLeft >= max - 2 ? 'end' : '';
        if (edge === this.edge) return;
        if (this.edge) this.track.dispatchEvent(new CustomEvent('scroll:edge-leaving', { detail: { position: this.edge } }));
        if (edge) this.track.dispatchEvent(new CustomEvent('scroll:edge-nearing', { detail: { position: edge } }));
        this.edge = edge;
      }

      // Auto-advance (phone only): after the centred reel plays through, or after "max seconds".
      // Holds while the shopper is touching, listening with sound, or has the player open.
      tick() {
        if (!this.autoOn || DESK.matches || REDUCED.matches || !this.inView || this.lb?.open) return;
        const v = this.videos[this.active];
        if (!v || !v.muted || v.paused || Date.now() - this.lastTouch < 4000) return;
        this.elapsed += 0.25;
        const dur = isFinite(v.duration) && v.duration > 0 ? v.duration : 12;
        const limit = this.maxSec > 0 ? Math.min(dur, this.maxSec) : dur;
        if (this.elapsed >= limit) { this.elapsed = 0; this.goTo(this.active + 1); }
      }

      /* ---------- expanded player ---------- */
      buildLb() {
        const el = document.createElement('div');
        el.className = 'vr-lb';
        el.setAttribute('role', 'dialog');
        el.setAttribute('aria-modal', 'true');
        el.setAttribute('aria-label', 'Customer videos');
        el.innerHTML = `<div class="vr-lb__track"></div>
          <button type="button" class="vr-lb__side prev" aria-label="Previous video">${ICON.left}</button>
          <button type="button" class="vr-lb__side next" aria-label="Next video">${ICON.right}</button>`;
        const track = el.querySelector('.vr-lb__track');
        const slides = this.cards.map((card, i) => {
          const s = document.createElement('div');
          s.className = 'vr-lb__slide';
          const buy = card.querySelector('template.vr__buy');
          s.innerHTML = `<div class="vr-lb__frame">
              <video playsinline loop preload="none" ${card.dataset.poster ? `poster="${card.dataset.poster}"` : ''}></video>
              <div class="vr-lb__prog"><i></i></div>
              <div class="vr-lb__play">${ICON.play}</div>
              <div class="vr-lb__ctl">
                <button type="button" class="vr-lb__mute" aria-label="Turn sound off" aria-pressed="true">${ICON.muted}${ICON.sound}</button>
                <button type="button" class="vr-lb__close" aria-label="Close">${ICON.close}</button>
              </div>
            </div>`;
          const v = s.querySelector('video');
          v.dataset.src = card.dataset.full;
          if (buy) {
            const frame = s.querySelector('.vr-lb__frame');
            frame.appendChild(buy.content.cloneNode(true));
            const card2 = frame.querySelector('.vr-lb__buy');
            // Opening quick-add (or adding) pauses the reel so it isn't talking under the drawer.
            card2.querySelector('.button')?.addEventListener('click', () => v.pause());
            const single = card2.querySelector('.vr-lb__single');
            if (single) single.querySelector('.button').addEventListener('click', (e) => this.addToCart(single.dataset.variantId, e.currentTarget, card2.querySelector('.vr-lb__err')));
          }
          v.addEventListener('timeupdate', () => {
            if (v.duration) s.querySelector('.vr-lb__prog i').style.width = `${(v.currentTime / v.duration) * 100}%`;
          });
          v.addEventListener('click', () => {
            if (v.paused) playSafe(v); else v.pause();
          });
          v.addEventListener('play', () => s.querySelector('.vr-lb__frame').classList.remove('is-paused'));
          v.addEventListener('pause', () => s.querySelector('.vr-lb__frame').classList.add('is-paused'));
          s.querySelector('.vr-lb__mute').addEventListener('click', () => { this.lb.sound = v.muted; this.applySound(); });
          s.querySelector('.vr-lb__close').addEventListener('click', () => this.closeLb());
          track.appendChild(s);
          return { s, v };
        });
        track.addEventListener('scroll', () => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== this.lb.index) this.lbActivate(i);
        }, { passive: true });
        el.querySelector('.vr-lb__side.prev').addEventListener('click', () => this.lbGo(this.lb.index - 1));
        el.querySelector('.vr-lb__side.next').addEventListener('click', () => this.lbGo(this.lb.index + 1));
        el.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.closeLb();
          if (e.key === 'ArrowRight') this.lbGo(this.lb.index + 1);
          if (e.key === 'ArrowLeft') this.lbGo(this.lb.index - 1);
        });
        el.tabIndex = -1;
        document.body.appendChild(el);
        this.lb = { el, track, slides, index: -1, open: false, sound: true };
      }

      // Same contract as the theme's product form: bundle the drawer's sections into the add,
      // then fire variant:add + cart:change so the cart drawer re-renders and opens.
      async addToCart(variantId, btn, err) {
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        err.hidden = true;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
          const res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections }),
          });
          const json = await res.json();
          if (!res.ok) throw new Error(json.description || json.message || 'Could not add this item.');
          if (window.themeVariables?.settings?.cartType === 'page') { window.location.href = `${root}cart`; return; }
          const cart = await (await fetch(`${root}cart.js`)).json();
          cart.sections = json.sections;
          this.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [json], cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
        } catch (e) {
          err.textContent = e.message || 'Could not add this item.';
          err.hidden = false;
        } finally {
          btn.setAttribute('aria-busy', 'false');
        }
      }

      openLb(i) {
        if (!this.lb) this.buildLb();
        const lb = this.lb;
        this.videos.forEach((v) => { v.pause(); if (!v.muted) this.setMuted(v, true); });
        lb.open = true;
        lb.sound = true;
        lb.opener = document.activeElement;
        lb.el.classList.add('is-open');
        lock();
        lb.index = -1;
        lb.track.scrollLeft = i * lb.track.clientWidth;
        this.lbActivate(i);
        lb.el.focus({ preventScroll: true });
      }

      closeLb() {
        const lb = this.lb;
        if (!lb?.open) return;
        lb.open = false;
        lb.slides.forEach(({ v }) => v.pause());
        lb.el.classList.remove('is-open');
        unlock();
        lb.opener?.focus?.({ preventScroll: true });
        this.visible.forEach((v) => playSafe(v));
      }

      lbGo(i) {
        const n = this.lb.slides.length;
        if (i < 0 || i >= n) return;
        this.lb.track.scrollTo({ left: i * this.lb.track.clientWidth, behavior: REDUCED.matches ? 'auto' : 'smooth' });
      }

      // One player at a time: the slide you land on plays, everything else pauses.
      lbActivate(i) {
        const lb = this.lb;
        lb.index = i;
        lb.slides.forEach(({ v }, j) => {
          const near = Math.abs(j - i) <= 1;
          if (near && !v.src) { v.src = v.dataset.src; v.preload = j === i ? 'auto' : 'metadata'; }
          if (j !== i) v.pause();
        });
        this.applySound();
        const v = lb.slides[i].v;
        const p = v.play();
        // Browsers can refuse sound without a fresh tap; fall back to muted instead of a frozen frame.
        if (p && p.catch) p.catch(() => { lb.sound = false; this.applySound(); playSafe(v); });
        lb.el.querySelector('.vr-lb__side.prev').disabled = i === 0;
        lb.el.querySelector('.vr-lb__side.next').disabled = i === lb.slides.length - 1;
      }

      applySound() {
        const lb = this.lb;
        lb.slides.forEach(({ s, v }, j) => {
          v.muted = j === lb.index ? !lb.sound : true;
          const b = s.querySelector('.vr-lb__mute');
          b.setAttribute('aria-pressed', String(!v.muted));
          b.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
        });
      }
    }
    customElements.define('video-reels', VideoReels);
  })();

  } catch(e) { console.error(e); }
})();
})();
